import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-manage min" }
const _hoisted_2 = { class: "search-area" }
const _hoisted_3 = {
  key: 0,
  class: "result"
}
const _hoisted_4 = {
  key: 0,
  class: "plan is-center"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "plan is-center"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "placeholder-message" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "pagination-area is-small" }

import { ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from "vue-router";
import { Plan } from '@/types/Plan';
import { getPlanList } from '@/api';
import { getBeusPlanLName, getBaPlanLName } from "@/utils";
import { ElMessageBox } from 'element-plus';
import type { TableInstance } from 'element-plus';
import StatusTag from '@/components/StatusTag.vue';
import IconBeusGray from '@/assets/images/ico-beus-g.svg';
import IconBiGray from '@/assets/images/ico-bi-g.svg';
import CommonLoader from '@/components/CommonLoader.vue';
import CommonError from '@/components/CommonError.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanListPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const data = ref<Plan[]>([]);
const totalCount = ref<number>(0);
const loading = ref<boolean>(false);
const isError = ref<boolean>(false);
const isResult = ref(false);
const searchKeyword = ref('');
const clearSearch = () => {
  searchKeyword.value = '';
};
const currentPage = ref<number>(1);
const pageSize = ref<number>(30);
const sortValue = ref<string | undefined>(undefined);
const selectedStatus = ref<string[] | undefined>([]);

const fetchData = async () => {
  loading.value = true;
  const params: Record<string, any> = {
    userId: searchKeyword.value,
    pageNum: currentPage.value,
    pageSize: pageSize.value,
  }

  if (sortValue.value) {
    params.sort = sortValue.value;
  }

  if (selectedStatus.value && selectedStatus.value.length > 0) {
    params.search = { status: selectedStatus.value };
  }

  // console.log('plan payload:',params);
  try {
    const response = await getPlanList(params);
    if(response.success) {
      // console.log('result',response.result);

      if (response.result.count === 0) {
        ElMessageBox.alert('검색결과가 없습니다. 검색 조건을 변경해주세요.', {
          confirmButtonText: '확인',
        });
        return;
      } else {
        totalCount.value = response.result.count;
        data.value = response.result.list;
      }
    }
    isResult.value = true;
  } catch (error) {
    loading.value = false;
    isError.value = true;
    console.error('Error Message:', error)
  } finally {
    loading.value = false;
  }
}

const handleSearch = async () =>  {
  if(searchKeyword.value.length < 2) {
    ElMessageBox.alert('검색어는 2자 이상 입력해주세요.', {
      confirmButtonText: '확인',
    });
    return;
  }
  router.replace({ path: '/request/plan', query: { param: searchKeyword.value } });
}

const handleSizeChange = (size: number) => {
  pageSize.value = size;
  fetchData();
}
const handlePageChange = (page: number) => {
  currentPage.value = page;
  fetchData();
};

watch(
  () => route.query.param,
  (newParam) => {
    if (newParam) {
      searchKeyword.value = newParam as string;
      fetchData();
    }
  },
  { immediate: true }
);

onMounted(() => {
  if (route.query.param) {
    searchKeyword.value = route.query.param as string;
    fetchData();
  }
});

const handleSortChange = ({ prop, order }: { prop: string; order: string }) => {
  if (order === "ascending") {
    sortValue.value = prop;
  } else if (order === "descending") {
    sortValue.value = `-${prop}`
  } else {
    sortValue.value = undefined;
  }
  fetchData();
};

const handleFilterChange = (filters: Record<string, string[]>) => {
  selectedStatus.value = filters.status || [];
  fetchData();
};

const tableRef = ref<TableInstance>()

const handleReset = () => {
  currentPage.value = 1;
  pageSize.value = 30;
  tableRef.value?.clearFilter();
  tableRef.value?.clearSort();
  sortValue.value = undefined;
  selectedStatus.value = undefined;
  fetchData(); 
}


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: searchKeyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
        placeholder: "뷰저블 계정을 입력하세요.",
        clearable: "",
        size: "large",
        class: "input-search",
        onClear: clearSearch,
        onKeyup: _withKeys(handleSearch, ["enter"])
      }, {
        append: _withCtx(() => [
          _createVNode(_component_el_button, {
            "aria-label": "검색",
            onClick: handleSearch
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-magnifying-glass" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "info",
        size: "large",
        class: "btn-reset",
        onClick: handleReset
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-rotate-left" })
        ]),
        _: 1
      }),
      (isResult.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createElementVNode("strong", null, _toDisplayString(`${data.value[0].companyName}(${data.value[0].userId})`), 1),
            _cache[1] || (_cache[1] = _createTextVNode("의 플랜이 총 ")),
            _createElementVNode("strong", null, _toDisplayString(totalCount.value), 1),
            _cache[2] || (_cache[2] = _createTextVNode(" 개 있습니다. "))
          ]))
        : _createCommentVNode("", true)
    ]),
    (!loading.value && !isError.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_el_table, {
            data: data.value,
            style: {"width":"800px"},
            ref_key: "tableRef",
            ref: tableRef,
            onSortChange: handleSortChange,
            onFilterChange: handleFilterChange
          }, {
            empty: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                (!searchKeyword.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, " 검색어를 입력하세요. "))
                  : (_openBlock(), _createElementBlock("p", _hoisted_10, " 검색 결과가 없습니다. "))
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "requestId",
                label: "리퀘스트 ID",
                width: "200",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "status",
                label: "플랜 상태",
                width: "120",
                align: "center",
                "column-key": "status",
                filters: [
            { text: '대기', value: 'waiting' },
            { text: '적용중', value: 'use' },
            { text: '종료', value: 'complete' }
          ]
              }, {
                default: _withCtx((scope) => [
                  (scope.row.status === 'waiting')
                    ? (_openBlock(), _createBlock(StatusTag, {
                        key: 0,
                        color: "gray",
                        size: "small",
                        text: "대기"
                      }))
                    : _createCommentVNode("", true),
                  (scope.row.status === 'use')
                    ? (_openBlock(), _createBlock(StatusTag, {
                        key: 1,
                        color: "blue",
                        size: "small",
                        text: "적용중"
                      }))
                    : _createCommentVNode("", true),
                  (scope.row.status === 'complete')
                    ? (_openBlock(), _createBlock(StatusTag, {
                        key: 2,
                        color: "gray_dark",
                        size: "small",
                        text: "종료"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "플랜명",
                width: "160",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.beusPlanNumber)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createElementVNode("img", {
                          src: _unref(IconBeusGray),
                          alt: "히트맵 플랜"
                        }, null, 8, _hoisted_5),
                        _createTextVNode(" " + _toDisplayString(_unref(getBeusPlanLName)(Number(scope.row.beusPlanNumber))), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (scope.row.baPlanNumber)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _createElementVNode("img", {
                          src: _unref(IconBiGray),
                          alt: "저니맵 플랜"
                        }, null, 8, _hoisted_7),
                        _createTextVNode(" " + _toDisplayString(_unref(getBaPlanLName)(Number(scope.row.baPlanNumber))), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "useStartDate",
                label: "사용 시작일",
                width: "160",
                align: "center",
                sortable: "custom"
              }),
              _createVNode(_component_el_table_column, {
                prop: "useEndDate",
                label: "사용 종료일",
                width: "160",
                align: "center",
                sortable: "custom"
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_pagination, {
              "current-page": currentPage.value,
              "page-size": pageSize.value,
              "page-sizes": [10, 30, 50],
              total: totalCount.value,
              layout: "sizes, prev, pager, next",
              class: "small",
              onSizeChange: handleSizeChange,
              onCurrentChange: handlePageChange
            }, null, 8, ["current-page", "page-size", "total"])
          ])
        ], 64))
      : (loading.value)
        ? (_openBlock(), _createBlock(CommonLoader, { key: 1 }))
        : (isError.value && !loading.value)
          ? (_openBlock(), _createBlock(CommonError, {
              key: 2,
              message: "서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.<br/> 문제가 지속되면 관리자에게 문의하세요."
            }))
          : _createCommentVNode("", true)
  ]))
}
}

})